import React from 'react';
import { BookOpenIcon, ZapIcon, LandmarkIcon, PercentIcon, FileCheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="flex flex-col w-full" data-id="element-191">
      {/* Unique Mechanism */}
      <div className="bg-navy text-white py-16 px-4 relative overflow-hidden" data-id="element-192">
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-193">
          <div className="inline-block bg-gold text-navy-dark font-bold px-4 py-1 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-194">
            La Solución Definitiva
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8" data-id="element-195">
            Presentamos el Sistema de Apalancamiento Gradual (S.A.G.)
          </h2>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-196">
            A diferencia de los consejos genéricos de internet, este método está
            diseñado específicamente para la mujer inmigrante. No se trata de
            pedir préstamos locos, sino de "alquilar" reputación y usar
            herramientas de autoconstrucción que los bancos no te cuentan,
            permitiéndote aparecer en el radar de los 3 burós de crédito en
            menos de 45 días.
          </p>
        </div>

        {/* Decorative gold lines */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-197"></div>
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-198"></div>
      </div>

      {/* What You Get */}
      <div className="bg-gray-light py-20 px-4" data-id="element-199">
        <div className="max-w-4xl mx-auto" data-id="element-200">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-12 text-center" data-id="element-201">
            Esto es lo que recibes hoy
          </h2>

          <div className="space-y-6" data-id="element-202">
            {/* Item 1 */}
            <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gold flex flex-col md:flex-row items-start md:items-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-203">
              <div className="bg-gold-light p-4 rounded-full mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-204">
                <BookOpenIcon className="w-8 h-8 text-navy" data-id="element-205" />
              </div>
              <div data-id="element-206">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-207">
                  La Guía Maestra "Crédito USA Desde Cero"
                </h3>
                <p className="text-text-muted" data-id="element-208">
                  El paso a paso escrito en español claro, sin palabras técnicas
                  confusas.
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gold flex flex-col md:flex-row items-start md:items-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-209">
              <div className="bg-gold-light p-4 rounded-full mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-210">
                <ZapIcon className="w-8 h-8 text-navy" data-id="element-211" />
              </div>
              <div data-id="element-212">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-213">
                  El Método del Acelerador de Sangre
                </h3>
                <p className="text-text-muted" data-id="element-214">
                  Cómo usar el historial de un familiar para saltar de 0 a 680
                  puntos en un solo mes.
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gold flex flex-col md:flex-row items-start md:items-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-215">
              <div className="bg-gold-light p-4 rounded-full mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-216">
                <LandmarkIcon className="w-8 h-8 text-navy" data-id="element-217" />
              </div>
              <div data-id="element-218">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-219">
                  Lista de Bancos "Amigos del Inmigrante"
                </h3>
                <p className="text-text-muted" data-id="element-220">
                  Los lugares exactos donde sí te abren las puertas con ITIN.
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gold flex flex-col md:flex-row items-start md:items-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-221">
              <div className="bg-gold-light p-4 rounded-full mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-222">
                <PercentIcon className="w-8 h-8 text-navy" data-id="element-223" />
              </div>
              <div data-id="element-224">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-225">
                  La Regla del 30%
                </h3>
                <p className="text-text-muted" data-id="element-226">
                  El secreto matemático para que tu puntaje nunca baje, incluso
                  si usas tus tarjetas a diario.
                </p>
              </div>
            </div>

            {/* Item 5 */}
            <div className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gold flex flex-col md:flex-row items-start md:items-center transform transition hover:-translate-y-1 hover:shadow-md" data-id="element-227">
              <div className="bg-gold-light p-4 rounded-full mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-228">
                <FileCheckIcon className="w-8 h-8 text-navy" data-id="element-229" />
              </div>
              <div data-id="element-230">
                <h3 className="text-xl font-bold text-navy mb-2" data-id="element-231">
                  Checklist de Documentos
                </h3>
                <p className="text-text-muted" data-id="element-232">
                  Para que tu primera aplicación sea aprobada a la primera.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}